import React, { useState, useEffect, lazy, Suspense } from 'react';

// Above-the-fold components (eager load)
import HeroSection from '../components/landing/HeroSection';
import Navigation from '../components/landing/Navigation';

// Below-the-fold components (lazy load)
const ScenarioExpertise = lazy(() => import('../components/landing/ScenarioExpertise'));
const WhoIsThisFor = lazy(() => import('../components/landing/WhoIsThisFor'));
const HowItWorks = lazy(() => import('../components/landing/HowItWorks'));
const ScenarioShowcase = lazy(() => import('../components/landing/ScenarioShowcase'));
const TrustSignals = lazy(() => import('../components/landing/TrustSignals'));
const CaseStudies = lazy(() => import('../components/landing/CaseStudies'));
const PricingSection = lazy(() => import('../components/landing/PricingSection'));
const FAQSection = lazy(() => import('../components/landing/FAQSection'));
const LeadForm = lazy(() => import('../components/landing/LeadForm'));
const Footer = lazy(() => import('../components/landing/Footer'));

const LandingPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="landing-page bg-white">
      <Navigation isScrolled={isScrolled} />
      <main id="main-content" role="main">
        {/* Above-the-fold - Load immediately */}
        <HeroSection />
        
        {/* Below-the-fold - Lazy load with loading fallback */}
        <Suspense fallback={
          <div className="flex justify-center items-center py-20">
            <div className="loading-spinner" role="status" aria-label="İçerik yükleniyor"></div>
          </div>
        }>
          <ScenarioExpertise />
          <WhoIsThisFor />
          <HowItWorks />
          <ScenarioShowcase />
          <TrustSignals />
          <CaseStudies />
          <PricingSection />
          <FAQSection />
          <LeadForm />
        </Suspense>
      </main>
      
      {/* Footer - Lazy load */}
      <Suspense fallback={<div style={{ height: '200px' }} />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default LandingPage;